import React from 'react';
import '../styles/Stats.css';

function Stats({ stats }) {
  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-icon airbnb">🏠</div>
        <div className="stat-content">
          <p className="stat-label">From Airbnb</p>
          <p className="stat-value">{stats.fromAirbnb}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon booking">🌐</div>
        <div className="stat-content">
          <p className="stat-label">From Booking.com</p>
          <p className="stat-value">{stats.fromBooking}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon manual">🔒</div>
        <div className="stat-content">
          <p className="stat-label">Manual Blocks</p>
          <p className="stat-value">{stats.fromManual}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon total">📅</div>
        <div className="stat-content">
          <p className="stat-label">Total Reservations</p>
          <p className="stat-value">{stats.totalReservations}</p>
        </div>
      </div>
    </div>
  );
}

export default Stats;
